import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import React from 'react';
import { Route } from 'react-router-dom';
import { UsersPage } from './components/UsersPage';

export function UsersRouter() {
  return (
    <RoutesWith404>
      <Route index element={<UsersPage />} />
    </RoutesWith404>
  );
}
